import { InjectionToken } from "@angular/core";
import { IOfflineService } from "./offline-service.interface";

export const OFFLINE_SERVICE = new InjectionToken<IOfflineService>('OFFLINE_SERVICE');